// extracted by mini-css-extract-plugin
module.exports = {"container":"EmailSignatures_container__1uYIh"};